<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        <span v-if="from=='sp'">{{ edit ? `Edit Sub Partner` : "Add Sub Partner" }}</span>
        <span v-else>{{ edit ? `Edit Partner` : "Add Partner" }}</span>
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.name"
              label="Name*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.code"
              label="Code*"
              outlined
              dense
              maxlength="3"
              hide-details="auto"
              :readonly="edit"
              :rules="[rules.required, rules.code]"
              @input="form.code = form.code.toUpperCase()"
          /></v-col>
          <v-col cols="6"
            ><v-select
              v-model="form.type"
              :items="typeItems"
              label="Type*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            ></v-select
          ></v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model.trim="form.programs"
              :items="programs"
              :item-text="
                (program) =>
                  `${program.degree?.short_name || ''}  ${
                    program.specialization ? ' - ' : ''
                  } ${program.specialization || ''}`
              "
              item-value="id"
              label="Programme*"
              chips
              small-chips
              outlined
              multiple
              dense
              hide-details="auto"
              :rules="[rules.required]"
            >
              <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip small class="ma-1" outlined>
                    {{
                      `${item.degree?.short_name || ""}${
                        item.specialization ? " - " : ""
                      }${item.specialization || ""}`
                    }}
                  </v-chip>
                </template>
                <template v-else-if="index === 2">
                  <span class="ma-1 text-caption">
                    +{{ form.programs.length - 2 }} other{{
                      form.programs.length - 2 > 1 ? "s" : ""
                    }}
                  </span>
                </template>
              </template>
            </v-autocomplete></v-col
          >
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.email"
              label="Email*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required, rules.email]"
          /></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.mobile_no"
              label="Mobile Number*"
              outlined
              dense
              maxlength="10"
              hide-details="auto"
              :rules="[rules.required, rules.mobile]"
          /></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.whatsapp_mobile_no"
              label="Whatsapp Number*"
              outlined
              dense
              maxlength="10"
              hide-details="auto"
              :rules="[rules.required, rules.mobile]"
          /></v-col>
          <v-col cols="6"></v-col>
          <v-col cols="4">
            <div class="d-flex justify-start">
              <v-checkbox
                v-model="form.adm_approval_reqd"
                hide-details="auto"
                class="mt-0"
              ></v-checkbox>
              <label class="mt-1 form-label"> Application Approval Required </label>
            </div>
          </v-col>
          <v-col cols="4">
            <div class="d-flex justify-start">
              <v-checkbox
                v-model="form.adm_applicant_fee_collect"
                hide-details="auto"
                class="mt-0"
              ></v-checkbox>
              <label class="mt-1 form-label"> Collect Fee </label>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    partner: {
      type: Object,
      default: () => {},
    },
    programs: {
      type: Array,
      default: () => [],
    },
    partners: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    from: {
      type: String,
      default: () => "",
    },
    partnerId: {
     type: Number,
    }
  },
  components: {},
  data() {
    return {
      rules,
      form: {
      },
    };
  },
  computed: {
    typeItems() {
      const selfTaken = (this.partners || []).some(
        (p) => p.type === "Self" && (!this.edit || p.id !== this.form.id)
      );
      return selfTaken
        ? ["Business", "Sponsor", "Institute"]
        : ["Self", "Business", "Sponsor", "Institute"];
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      if (this.edit) {
        this.form = { ...this.partner };
        this.existing_programs = (this.form.programs || []).map((p) => p.id);
        this.form.programs = (this.form.programs || []).map((p) => p.id);
      }
    },

    save() {
      if (!this.$refs.form.validate()) return;
      if(this.from == 'sp'){
          this.form.level="S";
          this.parent_id = this.form.parent_id
        }
      if (this.edit) {
        const oldIds = this.existing_programs || [];
        const newIds = this.form.programs;
        this.form.delete_programs = oldIds.filter((id) => !newIds.includes(id));
        this.form.create_programs = newIds.filter((id) => !oldIds.includes(id));
        this.$emit("update", this.form);
      } else {
        this.form.create_programs = this.form.programs;
        this.form.active = true;
        this.$emit("create", this.form);
      }
    },
  },
};
</script>

<style scoped>
.form-label {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
